import React from 'react';
import {
	Dialog,
	DialogContent,
	IconButton,
	Typography,
	Box,
} from '@mui/material';
import { Ticket } from '../types/ticket';
import TicketRecord from './ticketRecord/TicketRecord';
import { ArrowBackIcon } from 'components/icons';
import { ParkingLocation } from '../types/parkingLocation';

interface TicketModalProps {
	open: boolean;
	selectedTicket: Ticket | null;
	onClose: () => void;
	parkingLocation: ParkingLocation;
}

const TicketModal: React.FC<TicketModalProps> = ({
	open,
	onClose,
	selectedTicket,
	parkingLocation,
}) => {
	if (!selectedTicket) return null;

	return (
		<Dialog
			open={open}
			onClose={onClose} // ✅ Clicking outside closes it
			fullWidth
			maxWidth="md" // ✅ Keeps the same width styling
			PaperProps={{
				sx: {
					borderRadius: 2,
					overflow: 'auto',
					height: { xs: '90vh', md: '80vh' },
					p: 1,
				},
			}}
		>
			<DialogContent sx={{ p: 1 }}>
				<Box
					display="flex"
					justifyContent="space-between"
					alignItems="center"
					pb={2}
				>
					<Box display="flex" alignItems="center" gap={1}>
						<IconButton onClick={onClose}>
							<ArrowBackIcon />
						</IconButton>
						<Box onClick={onClose} sx={{ cursor: 'pointer' }}>
							<Typography variant="body2">
								Back to parking lot
							</Typography>
						</Box>
					</Box>
				</Box>

				<TicketRecord
					ticket={selectedTicket}
					showContentOnLoad={true}
					parkingLocation={parkingLocation}
				/>
			</DialogContent>
		</Dialog>
	);
};

export default TicketModal;
